import { common } from './common';

export const environment = {
  ...common,
  production: false,
  analyticsDashboardUrl: 'https://dashboard.xp-layer-dev.ethinking.xyz',
};
